module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('draggable', {
    attrs: {
      "options": {
        animation: 350,
        handle: '.menu-icon'
      }
    },
    on: {
      "end": _vm.delayedSave
    },
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-item hoverable clickable",
      on: {
        "click": function($event) {
          return _vm.toggleItem(item)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', [_c('div', {
      staticClass: "truncate pr-2"
    }, [(item.status == 'NA') ? _c('v-icon', {
      staticClass: "green--text"
    }, [_vm._v("highlight_off")]) : _c('v-icon', {
      class: {
        'green--text': item.status == 'C', 'grey--text': item.status == 'NA', 'grey--text text--lighten-2': item.status == 'O'
      }
    }, [_vm._v("check_circle_outline")])], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-grow": "1",
        "padding-top": "2px"
      }
    }, [(_vm.isCapitalised(item.text)) ? _c('span', {
      staticStyle: {
        "margin-top": "12px",
        "background-color": "#ddd",
        "border-radius": "5px",
        "font-weight": "bold",
        "font-size": "0.9em",
        "padding": "5px 8px"
      }
    }, [_vm._v(_vm._s(item.text))]) : _c('span', {
      staticStyle: {
        "margin-top": "12px"
      }
    }, [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "left": "",
        "nudge-width": 200
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticClass: "menu-icon"
          }, on), [_vm._v("keyboard_arrow_down")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": _vm.showAddItem
      }
    }, [_c('v-list-item-title', [_vm._v("Add Item")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteItem(item)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Item")])], 1)], 1)], 1)], 1)])])
  }), 0), _vm._v(" "), (!_vm.items.length && !_vm.editing) ? _c('div', {
    staticClass: "list-item hoverable clickable",
    on: {
      "click": _vm.showAddItem
    }
  }, [_c('v-icon', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "color": "grey lighten-2"
    }
  }, [_vm._v("add_circle_outline")]), _vm._v("\n        Add Items\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.editing) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newItem),
      expression: "newItem"
    }],
    ref: "addTextbox",
    staticClass: "quick-input",
    attrs: {
      "type": "text",
      "placeholder": "Add an item..."
    },
    domProps: {
      "value": (_vm.newItem)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelEditing($event)
      },
      "blur": _vm.cancelEditing,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addItem($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newItem = $event.target.value
      }
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43eb34b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/checklist.vue
// module id = 2526
// module chunks = 1